import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'

/** The one class-name joiner. Import this, never `clsx` directly. */
export const cn = (...inputs: ClassValue[]): string => clsx(...inputs)

export type { ClassValue }
